import { Component, ElementRef, OnDestroy, ViewChild } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { Store } from "@ngrx/store";
import { RootState } from "src/app/store";
import * as FromUser from "src/app/store/user/selectors";
import * as UserActions from "src/app/store/user/actions";
import { Observable, Subscription } from "rxjs";
import { UserDto } from "@api";
import { ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";
import { AppRoutes } from "src/app/constants";
import { EnvironmentService } from "src/app/services/environment/environment.service";

@Component({
  selector: "app-web-builder",
  templateUrl: "./web-builder.page.html",
  styleUrls: ["./web-builder.page.scss"],
})
export class WebBuilderPage implements OnDestroy {
  @ViewChild("webBuilder", { static: false }) public webBuilder: ElementRef<HTMLIFrameElement>;

  public user$: Observable<UserDto> = this.store.select(FromUser.selectUser);
  public customer$: Observable<any> = this.store.select(FromUser.selectCustomer);
  public logoImagePath = "./assets/logo.png";
  public avatarImagePath: string;
  public iframeSrc: SafeUrl;
  public breadcrumbs = [{ name: "Dashboard", link: `/${AppRoutes.webBuilder}/dashboard` }];

  private iframeSuccessfullyLoaded: boolean;
  private target: HTMLIFrameElement;
  private $customer: Subscription;

  constructor(
    private sanitizer: DomSanitizer,
    private store: Store<RootState>,
    private route: ActivatedRoute,
    private location: Location,
    private environmentService: EnvironmentService,
  ) {
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.environmentService.get<string>("webBuilderIframe"));
    this.location.onUrlChange(url => {
      if (url.includes(AppRoutes.webBuilder)) {
        this.store.dispatch(UserActions.loadUser());
        const path = url?.split("/").pop();
        if (this.iframeSuccessfullyLoaded && path) {
          this.webBuilder?.nativeElement?.contentWindow?.postMessage(`NAVIGATE---WOW---${path}`, "*");
        }
      }
    });
  }

  public ngOnDestroy(): void {
    this.$customer?.unsubscribe();
  }

  public iframeLoaded(event: Event): void {
    this.target = event.target as HTMLIFrameElement;

    this.customer$.subscribe(async customer => {
      this.target?.contentWindow.postMessage(`LOGIN---WOW---${JSON.stringify(customer)}`, "*");
      const params = this.route.snapshot.params;

      if (params?.path) {
        this.iframeSuccessfullyLoaded = true;
        setTimeout(() => this.target?.contentWindow.postMessage(`NAVIGATE---WOW---${params.path}`, "*"), 1000);
      }
    });
  }
}
